var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalLevelUps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#FF6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61111 5C5.2736 5 5 5.2736 5 5.61111V15.3889C5 15.7264 5.2736 16 5.61111 16H15.3889C15.7264 16 16 15.7264 16 15.3889C16 15.0514 15.7264 14.7778 15.3889 14.7778H6.22222V5.61111C6.22222 5.2736 5.94862 5 5.61111 5ZM13.4345 9.09198L11.6829 10.7819L10.8214 9.95075C10.5847 9.72233 10.2096 9.72233 9.97283 9.95075L7.32569 12.5046C7.0828 12.739 7.07587 13.1259 7.3102 13.3687C7.54454 13.6116 7.93141 13.6186 8.17431 13.3842L10.3971 11.2397L11.2586 12.0708C11.4953 12.2992 11.8704 12.2992 12.1072 12.0708L14.2988 9.95636L15.3395 10.997C15.5832 11.2408 16 11.0681 16 10.7234V8.05641C16 8.05579 16 8.05518 16 8.05456V7.83136C16 7.61767 15.8268 7.44444 15.6131 7.44444H15.3889C15.3888 7.44444 15.3888 7.44444 15.3888 7.44444H12.721C12.3763 7.44444 12.2037 7.86121 12.4474 8.10495L13.4345 9.09198Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalLevelUps);
export default __webpack_public_path__ + "static/media/TotalLevelUps.6f284337671f35d0e3d42d0a6b7fb786.svg";
export { ForwardRef as ReactComponent };